// @flow
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import View from './view';

import * as sagaAction from '../../sagas/saga_action';

export default withRouter(connect(state => ({
  chapterList: state.reducers.player.chapter_list,
}), dispatch => ({
  getChapterList: async () => {
    dispatch({
      type: sagaAction.SAGA_GET_CHAPTER_LIST,
    });
  },
}))(View));
